import React from 'react'
import styled from 'styled-components'

const TagContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 0em -0.5em 0 -0.5em;
`
const Tag = styled.div`
  border-radius: 30px;
  background-color: ${({ theme }) => theme.tags};
  padding: 0.25em 0.75em;
  margin: 0.5em;
  color: ${({ theme }) => theme.text};
  font-size: 16px;
`
const Tags = ({ tags }: { tags: string[] }) => (
  <TagContainer>
    {tags.map(tag => (
      <Tag key={tag}>{tag}</Tag>
    ))}
  </TagContainer>
)

export default Tags
